import styled from 'styled-components';
import { Button } from '../Button';
import { Box } from '../Core';

export const TOOLBAR_WIDTH = 40;
export const TOOLBAR_HEIGHT = 40;
export const AXIS_OFFSET = 100;

export const HistoricalPriceChartHeader = styled(Box)`
  height: ${TOOLBAR_HEIGHT}px;
  flex: 0 0 auto;
  border-bottom: solid 1px var(--backgroundBody);
  display: flex;
  position: relative;
  overflow: hidden;
`;

export const HistoricalPriceChartWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  .ag-charts-canvas-overlay > [role='presentation']:has(> .ag-charts-toolbar--vertical) {
    bottom: 0;
    left: 0;
    top: 0;
    width: ${TOOLBAR_WIDTH + 1}px;
    border-right: solid 1px var(--backgroundBody);

    .ag-charts-shared-toolbar {
      gap: 0;
      top: 0 !important;

      .ag-charts-toolbar__button {
        border: none;
        border-bottom: solid 1px var(--backgroundBody);
        background-color: transparent;
        height: ${TOOLBAR_HEIGHT + 1}px;
        width: ${TOOLBAR_WIDTH}px;

        &:hover {
          background-color: var(--backgroundDefaultButtonHover);
        }
      }
    }
  }

  .ag-charts-toolbar ag-charts-toolbar--vertical {
    bottom: 0;
  }
`;
HistoricalPriceChartWrapper.defaultProps = {
  w: '100%',
  h: '100%',
};

export const HeaderButton = styled(Button)<{ active: boolean }>`
  border-radius: 0;
  background-color: ${({ theme, active }) => (active ? theme.backgroundDefaultButtonActive : 'transparent')};
  height: 100%;
  font-weight: 400;
  /* aspect-ratio: 1; */
  width: ${TOOLBAR_WIDTH}px;
  color: ${({ theme, active }) => (active ? theme.colorTextImportant : theme.colorTextDefault)};

  border: none;
  border-right: solid 1px var(--backgroundBody);
`;
